// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__169OR","addWidgetButton":"Header_addWidgetButton__uJ6tW","dashboardTabs":"Header_dashboardTabs__2xGOn","active":"Header_active__3MFYc"};